<mat-form-field class="basic-date-picker" [ngClass]=" config.class" appearance="outline" [formGroup]="group">
  <mat-label class="select-label">{{ config.label }}</mat-label>
  <input matInput [matDatepicker]="picker" placeholder="{{config.placeholder}}" (focus)="picker.open()"  (click)="picker.open()" readonly [formControlName]="config.name"  [attr.name]="config.name" [max]="config.maxDate">
  <mat-datepicker-toggle id={{config.id}} matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  @if (group.controls[FormControlName].hasError('required') && group.controls[FormControlName].touched && config.showErrorText) {
    <mat-error>
      Field is required
    </mat-error>
  }
</mat-form-field>
